import { EventBus } from './EventBus';

/**
 * Used for internal communication between components.
 */
export const ninjaBus = new EventBus();
